export default "__VITE_PUBLIC_ASSET__ec236371__"